import { createContext } from 'react';

import type { useTheme } from '@/hooks/use-theme';

type ThemeContextType = ReturnType<typeof useTheme>;

export const ThemeContext = createContext<ThemeContextType | null>(null);
